import { Injectable } from '@angular/core';
import {
  BehaviorSubject,
  combineLatest,
  distinctUntilChanged,
  filter,
  map,
  Observable,
} from 'rxjs';
import { CompanyService } from 'src/app/core/services/company.service';
import { CompanyAccessService } from 'src/app/core/services/company-access.service';

@Injectable({ providedIn: 'root' })
export class OpenedByUrlAccessService {
  private openedCompanyIdSub = new BehaviorSubject<string | undefined>(
    undefined
  );


  public noAccess$: Observable<boolean> = combineLatest([
    this.openedCompanyIdSub,
    this.companyService.isLoading$,
  ]).pipe(
    filter(([, isLoading]) => !isLoading),
    map(() => this.hasNoAccess),
    distinctUntilChanged()
  );

  constructor(
    private companyService: CompanyService,
    private companyAccessService: CompanyAccessService
  ) {}

  public register(companyId?: string) {
    this.openedCompanyIdSub.next(companyId);
  }

  public clear() {
    this.openedCompanyIdSub.next(undefined);
  }

  public get hasNoAccess(): boolean {
    const openedCompanyId = this.openedCompanyIdSub.value;
    if (!openedCompanyId) return false;

    return this.companyAccessService.isCompanyOutsideUserAccess(
      openedCompanyId
    );
  }
}
